module.exports = __webpack_public_path__ + "static/technology-f0af12feac1bb7b2ab439f56f138b07e.png";